// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbsContainer":"bread-crumbs_breadCrumbsContainer__2TuO3"};